import { BORDER_RADIUS } from './constants';

type BorderRadiusArguments = number | string;

function processBorderRadius(value: BorderRadiusArguments) {
  if (typeof value === 'number') {
    return `${value * BORDER_RADIUS}px`;
  }
  return value;
}

export function calculateBorderRadius(radius: BorderRadiusArguments): string;
export function calculateBorderRadius(
  topLeftAndBottomRight: BorderRadiusArguments,
  topRightAndBottomLeft: BorderRadiusArguments,
): string;
export function calculateBorderRadius(
  topLeft: BorderRadiusArguments,
  topRightAndBottomRight: BorderRadiusArguments,
  bottomLeft: BorderRadiusArguments,
): string;
export function calculateBorderRadius(
  topLeft: number,
  topRight: number,
  bottomRight: number,
  bottomLeft: number,
): string;
export function calculateBorderRadius(...args: BorderRadiusArguments[]) {
  switch (args.length) {
    case 0:
      return '0';
    case 1:
      return processBorderRadius(args[0]);
    case 2: {
      const [topLeftAndBottomRight, topRightAndBottomLeft] = args;
      return `${processBorderRadius(topLeftAndBottomRight)} ${processBorderRadius(topRightAndBottomLeft)}`;
    }
    case 3: {
      const [topLeft, topRightAndBottomRight, bottomLeft] = args;
      return `${processBorderRadius(topLeft)} ${processBorderRadius(topRightAndBottomRight)} ${processBorderRadius(bottomLeft)}`;
    }
    case 4: {
      const [topLeft, topRight, bottomRight, bottomLeft] = args;
      return `${processBorderRadius(topLeft)} ${processBorderRadius(topRight)} ${processBorderRadius(bottomRight)} ${processBorderRadius(bottomLeft)}`;
    }
    default:
      throw new Error('Invalid number of arguments');
  }
}

export type BorderRadiusFunction = typeof calculateBorderRadius;
